import type { SVGProps } from 'react';

export function EmailMessage({ className = '', ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* envelope back */}
      <rect x="80" y="130" width="240" height="160" rx="4" />
      {/* envelope flap */}
      <path d="M80 135 L200 230 L320 135" />
      {/* letter sticking out (accent) */}
      <rect x="120" y="80" width="160" height="110" fill="#E7FF4D" stroke="currentColor" />
      <line x1="140" y1="110" x2="260" y2="110" stroke="currentColor" />
      <line x1="140" y1="130" x2="230" y2="130" stroke="currentColor" />
      <line x1="140" y1="150" x2="250" y2="150" stroke="currentColor" />
      {/* stamp */}
      <rect x="240" y="90" width="30" height="25" stroke="currentColor" strokeDasharray="3 3" fill="none" />
      {/* send arrow */}
      <path d="M300 300 l50 -20 l-50 -20 v15 h-30 v10 h30 z" fill="#E7FF4D" stroke="currentColor" />
    </svg>
  );
}
